module.exports = __webpack_public_path__ + "static/media/kishoriWebV2.10e8b45b.png";